var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"picker-goods"},[_c('SpFilterForm',{attrs:{"model":_vm.formData,"size":"small"},on:{"onSearch":_vm.onSearch,"onReset":_vm.onSearch}},[_c('SpFilterFormItem',{attrs:{"prop":"keywords"}},[_c('el-input',{attrs:{"clearable":"","placeholder":"请输入商品名称"},model:{value:(_vm.formData.keywords),callback:function ($$v) {_vm.$set(_vm.formData, "keywords", $$v)},expression:"formData.keywords"}})],1),_c('SpFilterFormItem',{attrs:{"prop":"approve_status"}},[_c('el-select',{attrs:{"clearable":"","placeholder":"请选择"},model:{value:(_vm.formData.approve_status),callback:function ($$v) {_vm.$set(_vm.formData, "approve_status", $$v)},expression:"formData.approve_status"}},_vm._l((_vm.salesStatus),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.title,"size":"mini","value":item.value}})}),1)],1),_c('SpFilterFormItem',{attrs:{"prop":"brand_id"}},[_c('el-select',{attrs:{"placeholder":"请选择品牌","remote":"","filterable":"","clearable":"","remote-method":_vm.getGoodsBranchList},model:{value:(_vm.formData.brand_id),callback:function ($$v) {_vm.$set(_vm.formData, "brand_id", $$v)},expression:"formData.brand_id"}},_vm._l((_vm.goodsBranchList),function(item){return _c('el-option',{key:item.attribute_id,attrs:{"label":item.attribute_name,"value":item.attribute_id}})}),1)],1),_c('SpFilterFormItem',{attrs:{"prop":"category"}},[_c('el-cascader',{attrs:{"placeholder":"请选择分类","clearable":"","options":_vm.categoryList,"props":{ value: 'category_id', label: 'category_name', checkStrictly: true }},model:{value:(_vm.formData.category),callback:function ($$v) {_vm.$set(_vm.formData, "category", $$v)},expression:"formData.category"}})],1),(_vm.isShowFormItem('distributor_id'))?_c('SpFilterFormItem',{attrs:{"prop":"distributor_id"}},[_c('SpSelectShop',{attrs:{"clearable":"","placeholder":"请选择店铺"},on:{"change":_vm.onSearch},model:{value:(_vm.formData.distributor_id),callback:function ($$v) {_vm.$set(_vm.formData, "distributor_id", $$v)},expression:"formData.distributor_id"}})],1):_vm._e()],1),_c('SpFinder',{ref:"finder",attrs:{"reserve-selection":"","row-key":"item_id","other-config":{
      'max-height': 416,
      'header-cell-class-name': _vm.cellClass
    },"url":"/goods/items","show-pager-text":"已选中：${n}","fixed-row-action":true,"setting":{
      columns: [
        { name: '商品ID', key: 'item_id', width: 80 },
        {
          name: '商品名称',
          key: 'page_name',
          render: (h, { row }) =>
            h('div', { class: 'item-info' }, [
              h('div', { class: 'item-image' }, [
                h('SpImage', {
                  props: {
                    src: row.pics[0],
                    width: 60,
                    height: 60
                  }
                })
              ]),
              h('div', { class: 'flex-col' }, [
                h('div', { class: 'item-name' }, row.itemName),
                h('div', { class: 'item-name' }, row.item_name_2)
              ])
            ])
        },
        {
          name: '内部货号',
          key: 'item_name_3',
          width: 100,
          render: (h, { row }) => h('span', {}, row.item_name_3)
        },
        {
          name: '价格（¥）',
          key: 'price',
          width: 150,
          render: (h, { row }) => h('span', {}, row.price / 100)
        },
        { name: '库存', key: 'store', width: 150 }
      ]
    },"hooks":{
      beforeSearch: _vm.beforeSearch,
      afterSearch: _vm.afterSearch
    }},on:{"select":_vm.onSelect,"selection-change":_vm.onSelectionChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }